class RetirementPlanner {
  constructor(retirementPlanner) {
    this.retirementPlanner = document.getElementById(retirementPlanner)
    
    this.applynowformdata = {
      firstName: "Please enter your first name",
      emailAddress: "Please enter your email address",
      contactNum: "Please provide your contact number",
    }

    var queryParam=this.getQueryParam("step1");
      if(queryParam && queryParam==="true")
      {
        $('[id$="retirement-planner-sitecore-form"]').hide();
        this.ShowRetirementPlannerSection("retirement-planner-step1");
        this.ShowRetirementPlannerSection("retirement-planner-main");
      }
      else {
        $('[id$="retirement-planner-main"]').hide();
        this.ShowRetirementPlannerSection("retirement-planner-sitecore-form");
      }
  
    this.init()
  }
  
  init() {
    if (this.retirementPlanner) {
      let calcType = "Monthly Payment"
     
        this.applynowformdata.firstName= this.retirementPlanner.getAttribute("data-firstname");
        this.applynowformdata.emailAddress=this.retirementPlanner.getAttribute("data-email");
        this.applynowformdata.contactNum= this.retirementPlanner.getAttribute("data-contactnumber");
      
      //BtnContinue Click
      let btnSaveApplyNow =
        this.retirementPlanner.querySelector("#btnSaveApplyNow")
      if (btnSaveApplyNow) {
        btnSaveApplyNow.addEventListener("click", () => {
          if (this.Validate_ApplyNow_FormWidget()) {
            this.ShowRetirementPlannerSection("retirement-planner-step1")
            //isApplyNowComplete = true;
          }
        })
      }
     
      let inputNumber = this.retirementPlanner.querySelector("#number")
      if (inputNumber) {
        inputNumber.addEventListener("input", () => {
          this.numberOnly(inputNumber)
        })
      }

      //Slider IDs
      let yearsTillRetirement = this.retirementPlanner.querySelector(
        "#years_till_retirement"
      )
      let yearsTillRetirementInput = this.retirementPlanner.querySelector(
        "#years_till_retirement_input"
      )
      let yearsAfterRetirement = this.retirementPlanner.querySelector(
        "#years_after_retirement"
      )
      let yearsAfterRetirementInput = this.retirementPlanner.querySelector(
        "#years_after_retirement_input"
      )
      let annualRate = this.retirementPlanner.querySelector("#annual_rate")
      let annualRateInput =
        this.retirementPlanner.querySelector("#annual_rate_input")
        let checkLang = document.querySelector("html").getAttribute('lang');
        if (yearsTillRetirement && yearsTillRetirementInput) {
          let tillMax = parseInt($("#years_till_retirement").attr('data-slider-max')) || 25;
          let tillMin = parseInt($("#years_till_retirement").attr('data-slider-min')) || 1;
          let tillStep = parseInt($("#years_till_retirement").attr('data-slider-step')) || 1;
          let tillValue = parseInt($("#years_till_retirement_input").attr('data-slider-initialvalue')) || 25;
      
          $("#years_till_retirement").slider({
              range: "min",
              value: tillValue,
              min: tillMin,
              max: tillMax,
              step: tillStep,
              isRTL: checkLang === 'ar' ? true : false,
              slide: function (event, ui) {
                  $("#years_till_retirement_input").val(ui.value);
              }
          });
      }
      

      if (yearsAfterRetirement && yearsAfterRetirementInput) {
        let afterMax = parseInt($("#years_after_retirement").attr('data-slider-max')) || 20;
        let afterMin = parseInt($("#years_after_retirement").attr('data-slider-min')) || 1;
        let afterStep = parseInt($("#years_after_retirement").attr('data-slider-step')) || 1;
        let afterValue = parseInt($("#years_after_retirement_input").attr('data-slider-initialvalue')) || 20;
    
        $("#years_after_retirement").slider({
            range: "min",
            value: afterValue,
            min: afterMin,
            max: afterMax,
            step: afterStep,
            isRTL: checkLang === 'ar' ? true : false,
            slide: function (event, ui) {
                $("#years_after_retirement_input").val(ui.value);
            },
        });
    }
    

    if (annualRate && annualRateInput) {
      let annualMax = parseInt($("#annual_rate").attr('data-slider-max')) || 20;
      let annualMin = parseInt($("#annual_rate").attr('data-slider-min')) || 1;
      let annualStep = parseInt($("#annual_rate").attr('data-slider-step')) || 1;
      let annualValue = parseInt($("#annual_rate_input").attr('data-slider-initialvalue')) || 1;
  
      $("#annual_rate").slider({
          range: "min",
          value: annualValue,
          min: annualMin,
          max: annualMax,
          step: annualStep,
          isRTL: checkLang === 'ar' ? true : false,
          slide: function (event, ui) {
              $("#annual_rate_input").val(ui.value);
          },
      });
  }
  

      this.clearFields()

      let btnRetirementPlannerSection1Next =
        this.retirementPlanner.querySelector(
          "#btnRetirementPlannerSection1Next"
        )
      let btnRetirementPlannerStep2Previous =
        this.retirementPlanner.querySelector(
          "#btnRetirementPlannerStep2Previous"
        )
      let btnRetirementPlannerStep2Calculate =
        this.retirementPlanner.querySelector(
          "#btnRetirementPlannerStep2Calculate"
        )
      let btnRetirementPlannerCalculate = this.retirementPlanner.querySelector(
        "#btnRetirementPlannerCalculate"
      )
      let recalculateRetirementPlanner = this.retirementPlanner.querySelector(
        "#recalculateRetirementPlanner"
      )
      let btnRetirementPlannerCalculatePrevious =
        this.retirementPlanner.querySelector(
          "#btnRetirementPlannerCalculatePrevious"
        )

      btnRetirementPlannerSection1Next.addEventListener("click", () =>
        this.ShowRetirementPlannerSection("retirement-planner-step2")
      )
      btnRetirementPlannerStep2Previous.addEventListener("click", () =>
        this.ShowRetirementPlannerSection("retirement-planner-step1")
      )
      btnRetirementPlannerStep2Calculate.addEventListener("click", () => {
        this.ShowRetirementPlannerSection("retirement-planner-re-calculate")
        this.CalculateRetirement(calcType)
      })
      btnRetirementPlannerCalculate.addEventListener("click", () => {
        this.ShowRetirementPlannerSection("retirement-planner-result")
        this.CalculateRetirement(calcType)
      })
      recalculateRetirementPlanner.addEventListener("click", () =>
        this.ShowRetirementPlannerSection("retirement-planner-re-calculate")
      )
      btnRetirementPlannerCalculatePrevious.addEventListener("click", () =>
        this.ShowRetirementPlannerSection("retirement-planner-step2")
      )

      $('[id$="applyNowFormErrorContainer"]').hide()
      $('[id$="retirement-planner-step1"]').hide()
      $('[id$="retirement-planner-step2"]').hide()
      $('[id$="retirement-planner-re-calculate"]').hide()
      $('[id$="retirement-planner-result"]').hide()
      $('[id$="tr-retirement-amount"]').hide()
      $('[id$="monthly-contribution-amount-row"]').show()
      $('[id$="monthly-saving-amount-row"]').hide()
      this.ShowRetirementPlannerSection("retirement-planner-apply-now")

      let radioMonthlyPayment = this.retirementPlanner.querySelector(
        "#radio-monthly-payment"
      )
      let radioRetirementAmounnt = this.retirementPlanner.querySelector(
        "#radio-retirement-amount"
      )

      if (radioMonthlyPayment) {
        radioMonthlyPayment.addEventListener("click", () => {
          $('[id$="tr-monthly-contribution"]').show()
          $('[id$="tr-retirement-amount"]').hide()

          calcType = "Monthly Payment"
          this.CalculateRetirement(calcType)

          $('[id$="monthly-contribution-amount-row"]').show()
          $('[id$="monthly-saving-amount-row"]').hide()
        })
      }

      if (radioRetirementAmounnt) {
        radioRetirementAmounnt.addEventListener("click", () => {
          $('[id$="tr-monthly-contribution"]').hide()
          $('[id$="tr-retirement-amount"]').show()

          calcType = "Retirement Amount"
          this.CalculateRetirement(calcType)

          $('[id$="monthly-contribution-amount-row"]').show()
          $('[id$="monthly-saving-amount-row"]').hide()
        })
      }
      var queryParam=this.getQueryParam("step1");
      if(queryParam && queryParam==="true")
      {
        var mainDiv=this.retirementPlanner.querySelector("#main-form-content");

        mainDiv && mainDiv.removeAttribute("data-hide")
        this.ShowRetirementPlannerSection("retirement-planner-step1")
      }
    }
  }

  Validate_ApplyNow_FormWidget() {
    let cnt = 0

    $('[id$="applyNowFormErrorContainer"] ul').empty()
    if ($('[id$="ToolsAndCalcPlanner"] #name').val() == "") {
      cnt++
      $('[id$="ToolsAndCalcPlanner"] #name').addClass("error")
      $('[id$="applyNowFormErrorContainer"] ul').append(
        "<li>" + this.applynowformdata.firstName + "</li>"
      )
    } else {
      $('[id$="ToolsAndCalcPlanner"] #name').removeClass("error")
    }
    if (
      !this.validateEmail($('[id$="ToolsAndCalcPlanner"] #email').val()) ||
      $('[id$="ToolsAndCalcPlanner"] #email').val() == ""
    ) {
      cnt++
      $('[id$="ToolsAndCalcPlanner"] #email').addClass("error")
      $('[id$="applyNowFormErrorContainer"] ul').append(
        "<li>" + this.applynowformdata.emailAddress + "</li>"
      )
    } else {
      $('[id$="ToolsAndCalcPlanner"] #email').removeClass("error")
    }
    if (
      $('[id$="ToolsAndCalcPlanner"] #number').val() == "" ||
      !this.validateNumber($('[id$="ToolsAndCalcPlanner"] #number').val())
    ) {
      cnt++
      $('[id$="ToolsAndCalcPlanner"] #number').addClass("error")
      $('[id$="applyNowFormErrorContainer"] ul').append(
        "<li>" + this.applynowformdata.contactNum + "</li>"
      )
    } else {
      $('[id$="ToolsAndCalcPlanner"] #number').removeClass("error")
    }
    if (cnt > 0) {
      $('[id$="applyNowFormErrorContainer"]').css("display", "block")
      return false
    } else {
      $('[id$="applyNowFormErrorContainer"]').css("display", "none")
      this.SaveApplyNowFormWidgetDataCall()
      return true
    }
  }

  validateEmail($email) {
    let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/
    if (!emailReg.test($email)) {
      return false
    } else {
      return true
    }
  }

  validateNumber($number) {
    let phoneReg = /^[0-9/#+-;*]*$/
    if (!phoneReg.test($number)) {
      return false
    } else {
      return true
    }
  }

  numberOnly(element) {
    // Get element by id which passed as parameter within HTML element event
    //let element = document.getElementById(id)
    // This removes any other character but numbers as entered by user
    element.value = element.value.replace(/[^0-9]/gi, "")
  }

  SaveApplyNowFormWidgetDataCall() {
    try {
      let productName = $(".span-apply-now-product-name").text()
      let fullname = $('[id$="ToolsAndCalcPlanner"] #name').val()
      let emailAddress = $('[id$="ToolsAndCalcPlanner"] #email').val()
      let contactNumber = $('[id$="ToolsAndCalcPlanner"] #number').val()
      let isADIBExistingCustomer = "No"
      if ($(".radio-existing-customer") != null) {
        isADIBExistingCustomer = $(
          '.radio-existing-customer input[type="radio"]:checked'
        ).val()
      }

      let pathArray = window.location.pathname.split("/")
      let secondLevelLocation = pathArray[1]
      let newURL =
        window.location.protocol +
        "//" +
        window.location.host +
        "/" +
        secondLevelLocation
      /*
      $.ajax({
        type: "POST",
        url: newURL + "/_vti_bin/listdataapi.aspx/SaveApplyNowWidgetData",
        data:
          "{'productName':'" +
          productName +
          "','fullName':'" +
          fullname +
          "','emailAddress':'" +
          emailAddress +
          "','contactNumber':'" +
          contactNumber +
          "','isADIBExistingCustomer':'" +
          isADIBExistingCustomer +
          "'}",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (msg) {
          if ($(".span-apply-now-continue-url").text() == "") {
            $('[id$="ToolsAndCalcPlanner"]').html(
              $(".span-apply-now-success-html").html()
            )
          } else {
            // redirect to continue URL
            window.location.href =
              newURL + "/" + $(".span-apply-now-continue-url").text()
          }
        },
      })
      */
    } catch (e) {}
  }

  CalculateRetirement(calculationType) {
    let monthly_need = $("#monthly_need").val().replace(/,/g, "")
    let years_till_retirement = $("#years_till_retirement_input").val()
    let years_after_retirement = $("#years_after_retirement_input").val()
    let rate = parseFloat($("#annual_rate_input").val())
    let currency_title = " AED "
    let pathname = window.location.href
    if (pathname.includes("/ar/")) {
      currency_title = " درهم"
    }

    let current_age = $('[id$="current_age"]').val()
    let retirement_age = $('[id$="retirement_age"]').val()
    let monthly_contribution = $('[id$="monthly_contribution"]')
      .val()
      .replace(/,/g, "")
    let existing_saving = $('[id$="existing_savings"]').val().replace(/,/g, "")
    let retirement_value_amount = $('[id$="retirement_amount"]')
      .val()
      .replace(/,/g, "")
    let annual_return = 4
    let inflation = 0
    let annual_retirement_amount = parseFloat(monthly_need * 12)
    let expression1 = parseFloat(1 + inflation)
    let annual_retirement_amount_at_retirement =
      annual_retirement_amount * Math.pow(expression1, years_till_retirement)
    let expression1_death = parseFloat(1 + inflation)
    let annual_retirement_amount_at_death =
      annual_retirement_amount_at_retirement *
      Math.pow(expression1_death, years_after_retirement)
    let expression_1_retirement_amount =
      (annual_retirement_amount_at_death +
        annual_retirement_amount_at_retirement) /
      2
    let total_retirement_amount =
      expression_1_retirement_amount * years_after_retirement
    let growth_rate = 0
    let nper = 0
    let pv = 0
    let PV = 0
    let pmt = 0
    let X = 0
    let FV = 0

    switch (calculationType) {
      case "Monthly Payment":
        growth_rate = parseFloat(annual_return) - parseFloat(inflation)
        growth_rate = parseFloat(growth_rate / 100)
        nper = parseFloat(retirement_age) - parseFloat(current_age)
        pv = parseFloat(existing_saving)
        pmt = monthly_contribution * 12
        X = Math.pow(1 + growth_rate, nper)
        FV = (-pmt + X * pmt + growth_rate * X * pv) / growth_rate
        FV = Math.round(FV)
        $('[id$="monthly-contribution-amount"]').text(
          currency_title +
            this.CommaFormatted(this.CurrencyFormatted(monthly_contribution))
        )
        $('[id$="total-saved-amount"]').text(
          currency_title +
            this.CommaFormatted(this.CurrencyFormatted(Math.round(FV)))
        )
        break
      case "Retirement Amount":
        growth_rate = parseFloat(annual_return) - parseFloat(inflation)
        growth_rate = parseFloat(growth_rate / 100 / 12)
        nper = parseFloat(retirement_age) - parseFloat(current_age)
        nper = nper * 12
        X = parseFloat(growth_rate / 100)
        X = Math.pow(1 + growth_rate, nper)
        PV =
          (growth_rate * (retirement_value_amount + X * existing_saving)) /
          (-1 + X)
        PV = PV / 10 // This needs to be tested and verified later
        let statement_text = "you need to save per month."
        $("#monthly-saving-amount").text(
          currency_title +
            this.CommaFormatted(this.CurrencyFormatted(parseInt(PV)))
        )
        $("#total-saved-amount").text(
          currency_title +
            this.CommaFormatted(this.CurrencyFormatted(retirement_value_amount))
        )
        break
      default:
        let rate_without_division = rate
        rate = rate / 12
        let per = 1
        nper = years_till_retirement * 12
        pv = parseFloat($("#existing_saving").val().replace(/,/g, ""))
        let fv = -total_retirement_amount
        let monthly_savings = pmt_result(rate, per, nper, pv, fv)
        $("#monthly-contribution-amount").text(
          currency_title +
            this.CommaFormatted(
              this.CurrencyFormatted(Math.abs(monthly_savings))
            )
        )
        $("#total-saved-amount").text(currency_title + total_retirement_amount)
        break
    }

    //gtagCalculatorRetirement();
  }

  CommaFormatted(amount) {
    let delimiter = "," // replace comma if desired
    let a1 = amount.split(".", 2)
    let d = a1[1]
    let i = parseInt(a1[0])
    if (isNaN(i)) {
      return ""
    }
    let minus = ""
    if (i < 0) {
      minus = "-"
    }
    i = Math.abs(i)
    let n = new String(i)
    let a = []
    while (n.length > 3) {
      let nn = n.substr(n.length - 3)
      a.unshift(nn)
      n = n.substr(0, n.length - 3)
    }
    if (n.length > 0) {
      a.unshift(n)
    }
    n = a.join(delimiter)
    if (d.length < 1) {
      amount = n
    } else {
      amount = n + "." + d
    }
    amount = minus + amount
    return amount
  }

  CurrencyFormatted(amount) {
    let i = parseInt(amount)
    if (isNaN(i)) {
      i = 0
    }
    let minus = ""
    if (i < 0) {
      minus = "-"
    }
    i = Math.abs(i)
    i = parseInt((i + 0.005) * 100)
    i = i / 100
    let s = new String(i)
    if (s.indexOf(".") < 0) {
      s += "."
    }
    if (s.indexOf(".") == s.length - 2) {
      s += "0"
    }
    s = minus + s
    return s
  }

  pmt_result(rate, per, nper, pv, fv) {
    fv = parseFloat(fv)
    nper = parseFloat(nper)
    pv = parseFloat(pv)
    per = parseFloat(per)
    if (per == 0 || nper == 0) {
      return 0
    }
    rate = eval(rate / (per * 100))
    let pmt_value = 0
    if (rate == 0) {
      pmt_value = -(fv + pv) / nper
    } else {
      x = Math.pow(1 + rate, nper)
      pmt_value = (rate * (fv + x * pv)) / (-1 + x)
    }
    pmt_value = Math.round(pmt_value)
    return pmt_value
  }

  ShowRetirementPlannerSection(sectionToShow) {
    $('[id$="retirement-planner-apply-now"]').hide()
    $('[id$="retirement-planner-step1"]').hide()
    $('[id$="retirement-planner-step2"]').hide()
    $('[id$="retirement-planner-re-calculate"]').hide()
    $('[id$="retirement-planner-result"]').hide()
    $("[id$=" + sectionToShow + "]").show()

    // if (sectionToShow == "retirement-planner-result") {
    //   if (window.screen.width > 800) {
    //     $("*").scrollTop(0)
    //   }
    // } else {
    //   $("*").scrollTop(0)
    // }
    //let plannerApplyNow = this.retirementPlanner.querySelector("#retirement-planner-apply-now");
    //let plannerStep1 = this.retirementPlanner.querySelector("#retirement-planner-step1");
    //let plannerStep2 = this.retirementPlanner.querySelector("#retirement-planner-step2");
    //let plannerReCalculate = this.retirementPlanner.querySelector("#retirement-planner-re-calculate");
    //let plannerResult = this.retirementPlanner.querySelector("#retirement-planner-result");
    //let plannerSectionToShow = this.retirementPlanner.querySelector("#" + sectionToShow);

    //if (plannerApplyNow) { plannerApplyNow.style.display = "none" }
    //if (plannerStep1) { plannerApplyNow.style.display = "none" }
    //if (plannerStep2) { plannerApplyNow.style.display = "none" }
    //if (plannerReCalculate) { plannerApplyNow.style.display = "none" }
    //if (plannerResult) { plannerApplyNow.style.display = "none" }
    //if (plannerSectionToShow) { plannerApplyNow.style.display = "block" }

    //if (sectionToShow === "retirement-planner-result") {
    //    if (window.screen.width > 800) {
    //        $('*').scrollTop(0);
    //    }
    //}
    //else {
    //    $('*').scrollTop(0);
    //}
  }

  clearFields() {
    let inputName = this.retirementPlanner.querySelector("#name")
    let inputEmail = this.retirementPlanner.querySelector("#email")
    let inputNumber = this.retirementPlanner.querySelector("#number")

    if (inputName) {
      inputName.value = ""
    }
    if (inputEmail) {
      inputEmail.value = ""
    }
    if (inputNumber) {
      inputNumber.value = ""
    }
  }

  trim(stringToTrim) {
    var s = ""

    for (var i = 0; i < stringToTrim.length; ++i) {
      if (stringToTrim.charAt(i) != " ") s += stringToTrim.charAt(i)
    }

    return s
  }

  IsAlphaNumeric(str) {
    var filter = /^[0-9a-zA-Z]+$/
    return filter.test(str)
  }

 getQueryParam(param) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(param);
}
}
export default RetirementPlanner
